import React from 'react';
import { MessageModal } from 'src/common/components/interactive-dialogue/components/interactive-dialog-content/interactive-dialog-content';
import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';

// This is a temp error component to server as a error message
// and allow the POS to be restarted until the POS startup rework has begun.

export const handleAccept = (): void => {
  window.location.reload();
};

const ServiceTypeLoadError: React.FC = (): JSX.Element => {
  return (
    <MessageModal
      type={EmeraldDialogTypes.Error}
      message='PosStartError'
      subMessage='PosStartErrorSubMessage'
      hideCancelButton={true}
      acceptButtonLabel='RestartPOS'
      onAccept={handleAccept}
    />
  );
};

export default ServiceTypeLoadError;
